import { authenticate, call, enableLogging, getRequestHandler, } from "./worker.js";
export const WIND_VECTOR_BYTES_PER_ELEMENT = 2 * Uint16Array.BYTES_PER_ELEMENT + //index
    7 * Float32Array.BYTES_PER_ELEMENT + //path + ws
    4 * Uint8Array.BYTES_PER_ELEMENT + //color(inc alpha)
    4 * Uint8Array.BYTES_PER_ELEMENT; //inner color(inc alpha)
export const distributionPositionIterator = (distribution) => {
    return {
        *[Symbol.iterator]() {
            const me = this;
            const tileKeys = Object.keys(distribution).sort();
            for (let tki = 0; tki < tileKeys.length; tki++) {
                let tileKey = tileKeys[tki];
                for (let position of tilePositionIterator(distribution[tileKey].positions)) {
                    yield position;
                }
            }
        },
    };
};
export const tilePositionIterator = (positions) => {
    return {
        *[Symbol.iterator]() {
            const _positions = positions.sort((p0, p1) => {
                let row = p1.index.y - p0.index.y;
                if (row === 0) {
                    return p0.index.x - p1.index.x;
                }
                else {
                    return row;
                }
            });
            for (let pi = 0; pi < _positions.length; pi++) {
                yield _positions[pi];
            }
        },
    };
};
export const WindFieldWorkerAPIFactory = (worker, listeners, host) => {
    worker.onmessage = getRequestHandler(self, listeners);
    return {
        authenticate: authenticate(worker, host),
        enableLogging: enableLogging(worker),
        init: (hpc, model) => {
            return call(worker, "init", [hpc, model]);
        },
        set: (profile) => {
            return call(worker, "set", [profile]);
        },
        getField: (time, dataView) => {
            const handler = (buf) => new DataView(buf);
            if (dataView) {
                return call(worker, "getField", [time, dataView.buffer], handler, [
                    dataView.buffer,
                ]);
            }
            else {
                return call(worker, "getField", [time], handler, []);
            }
        },
        getVector: (time, latLng) => {
            return call(worker, "getVector", [time, latLng]);
        },
        getRenderParameters: () => {
            return call(worker, "getRenderParameters", []);
        },
        addTile: (tile) => {
            return call(worker, "addTile", [tile]);
        },
        removeTile: (tile) => {
            return call(worker, "removeTile", [tile]);
        },
        tilesReady: (zoom, resolution, tileSize) => {
            return call(worker, "tilesReady", [zoom, resolution, tileSize]);
        },
    };
};
export const WindFieldWorkerNotificationsAPIFactory = (sender) => {
    return {
        cacheUpdated: (cacheKey) => {
            return call(sender, "cacheUpdated", [cacheKey]);
        },
        cacheComplete: (timeRange, grid, ready) => {
            return call(sender, "cacheComplete", [timeRange, grid, ready]);
        },
        positions: (position) => {
            return call(sender, "positions", [position]);
        },
        log: (content) => {
            return call(sender, "log", [content]);
        }
    };
};
